"use client";

import { createContext, useContext } from "react";

import { AllStatsigConfigs, DEFAULT_STATSIG_CONFIGS } from "@/lib/statsig-configs";

const StatsigConfigContext = createContext<AllStatsigConfigs>(DEFAULT_STATSIG_CONFIGS);

export function StatsigConfigProvider({
  children,
  ...statsigConfigs
}: AllStatsigConfigs & { children: React.ReactNode }) {
  return (
    <StatsigConfigContext.Provider value={statsigConfigs}>{children}</StatsigConfigContext.Provider>
  );
}

export function useStatsigConfig() {
  return useContext(StatsigConfigContext);
}
